import { PageHeader } from '@/components/common/PageHeader';

import { ContactoLaboratorioSection } from '../components/ContactoLaboratorioSection';
import { ContadorProtocoloSection } from '../components/ContadorProtocoloSection';
import { FirmanteSection } from '../components/FirmanteSection';

export function ConfiguracionPage(): JSX.Element {
  return (
    <>
      <PageHeader
        title="Configuración"
        subtitle="Parámetros generales del sistema."
      />
      <FirmanteSection />
      <ContactoLaboratorioSection />
      <ContadorProtocoloSection />
    </>
  );
}
